import {
	Alert,
	AlertDescription,
	AlertIcon,
	AlertTitle,
} from '@cocoonspace/ui/components/alert'
import { Button } from '@cocoonspace/ui/components/button'
import { Trans, useLingui } from '@lingui/react/macro'

import { useSpaceVisitStepper } from '../space-visit-stepper.context'

export const IntroStep = () => {
	const { t } = useLingui()
	const { setStep } = useSpaceVisitStepper()

	return (
		<div className='flex flex-col gap-4'>
			<div>
				<Trans>
					Vous avez la possibilité d'organiser{' '}
					<strong>3 visites de 30 minutes chacune</strong> sur les Cocoons de
					votre choix.
				</Trans>
			</div>

			<Alert className='border-border items-center border shadow-none'>
				<AlertIcon type='neutral' />

				<div>
					<AlertTitle className='flex items-center gap-2'>
						{t`Les visites ne sont pas prioritaires sur les réservations`}
					</AlertTitle>

					<AlertDescription>
						{t`Préférez une organisation de visite la veille pour le lendemain afin d'éviter de perdre votre créneau.`}
					</AlertDescription>
				</div>
			</Alert>

			<Button
				className='w-full'
				onClick={() => setStep('day')}
			>
				{t`Commencer`}
			</Button>
		</div>
	)
}
